<template>
  <CustomTitleBar title="充值" />
  <div class="page-content">
    <!-- 充值金额 -->
    <div class="recharge-amount">
      <div class="label">充值鲸油</div>
      <div class="amount">
        <!-- <span class="currency"></span> -->
        <input type="number" v-model="amount" placeholder="请输入充值数量" />
      </div>
    </div>

    <!-- 支付方式 -->
    <div class="payment-methods">
      <div class="label">充值方式</div>
      <div class="method-list">
        <div class="method-item" @click="payMethodChange('alipay')">
          <svgIcon name="alipay" size="20" />
          <span>支付宝</span>
          <svgIcon :name="payMethod === 'alipay' ? 'selected' : 'select'" size="20" />
        </div>
        <div class="method-item" @click="payMethodChange('wechat')">
          <svgIcon name="wechat" size="20" />
          <span>微信</span>
          <svgIcon :name="payMethod === 'wechat' ? 'selected' : 'select'" size="20" />
        </div>

        <!-- 银行卡支付 -->
        <div class="bank-pay">
          <div class="method-item">
            <svgIcon name="bankcard" size="20" />
            <span>银行卡支付</span>
          </div>
          <div class="bank-select">
            <div class="selected-bank" v-if="cardInfo.bankName" @click="payMethodChange('bank')">
              <span>{{ cardInfo.bankName }} ({{ cardInfo.bankAccountNo }})
                <span class="change-bank" @click="handleChangeBank">切换</span>
              </span>
              <svgIcon :name="payMethod === 'bank' ? 'selected' : 'select'" size="20" />
            </div>
            <div class="add-bank" @click="handleAddBank">添加银行卡
              <svgIcon name="arrow_right" size="10" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="bottom-section">
      <div class="service">
        如有疑问联系客服: <span @click="handleHelpClick">客服</span>
      </div>
      <button class="recharge-btn" @click="handleRecharge">充值</button>
      <div class="agreement">
        充值即代表同意<span>《鲸宝支付协议》</span>
      </div>
    </div>
  </div>

  <!-- 在template底部添加抽屉组件 -->
  <van-popup v-model:show="showDrawer" position="bottom" round :style="{ height: '60%' }">
    <div class="drawer-content">
      <div class="drawer-header">
        <span>选择银行卡</span>
        <span class="close-icon" @click="showDrawer = false">
          <svgIcon name="close" size="20" />
        </span>
      </div>
      <div class="bank-list">
        <div v-for="card in cardList" :key="card.id" class="bank-item" @click="selectBank(card)">
          <div class="bank-info">
            <svgIcon name="bankcard" size="20" />
            <div class="bank-detail">
              <div class="bank-name">{{ card.bankName }}</div>
              <div class="card-no">{{ card.bankAccountNo }}</div>
            </div>
          </div>
          <svgIcon :name="cardInfo.linkId === card.linkId ? 'selected' : 'select'" size="20" />
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { useRouter } from 'vue-router';
import { getCardList, recharge } from '@/api/wallet';
import { showToast } from 'vant';
const router = useRouter();
const amount = ref('');
const payMethod = ref('alipay');
const payMethodMap = {
  alipay: 1,
  wechat: 2,
  bank: 0
}

const cardList = ref<any[]>([]);
const cardInfo = ref<any>({});

const showDrawer = ref(false);

const handleRecharge = () => {
  //表单校验
  if (!amount.value) {
    showToast('请输入充值金额');
    return;
  }
  if (payMethod.value === 'bank' && !cardInfo.value.linkId) {
    showToast('请选择银行卡');
    return;
  }
  // 处理充值逻辑
  console.log('参数:', amount.value, cardInfo.value.linkId, payMethodMap[payMethod.value as keyof typeof payMethodMap]);
  recharge({
    amount: amount.value,
    linkId: cardInfo.value.linkId,
    remark: '',
    type: payMethodMap[payMethod.value as keyof typeof payMethodMap]
  }).then((res) => {
    if (res.code === 200) {
      //打开支付页面
      window.open(res.data.pageUrl, '_blank');
    }
  })
};

// 切换支付方式
const payMethodChange = (method: string) => {
  payMethod.value = method;
}

const handleAddBank = () => {
  router.push('/BankCard');
};

// 切换银行卡
const handleChangeBank = (e: Event) => {
  e.stopPropagation(); // 阻止冒泡
  showDrawer.value = true;
}

// 添加选择银行卡方法
const selectBank = (card: any) => {
  cardInfo.value = {
    linkId: card.linkId,
    bankName: card.bankName,
    bankAccountNo: card.bankAccountNo.slice(-4)
  }
  showDrawer.value = false;
  payMethod.value = 'bank';
}

//获取银行卡列表
const getList = async () => {
  const res = await getCardList().then((res) => {
    if (res.code === 200) {
      cardList.value = res.data
      if (cardList.value.length > 0) {
        cardInfo.value = {
          linkId: cardList.value[0].linkId,
          bankName: cardList.value[0].bankName,
          bankAccountNo: cardList.value[0].bankAccountNo.slice(-4)
        }
      } else {
        cardInfo.value = {
          linkId: null,
          bankName: null,
          bankAccountNo: null
        }
      }
    }
  })
}

onMounted(() => {
  getList()
})
</script>

<style scoped lang="scss">
.page-content {
  padding: 56px 16px 0;
}

.recharge-amount {
  background: #fff;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;

  .label {
    color: #333;
    margin-bottom: 12px;
  }

  .amount {
    display: flex;
    align-items: center;

    .currency {
      font-size: 24px;
      margin-right: 8px;
      white-space: nowrap;
    }

    input {
      font-size: 24px;
      border: none;
      outline: none;
      width: 100%;

      &::placeholder {
        color: #999; // 设置placeholder颜色
        font-size: 16px; // 设置placeholder字体大小
        font-weight: normal; // 设置placeholder字重
      }
    }
  }
}

.payment-methods {
  background: #fff;
  padding: 16px;
  border-radius: 8px;

  .label {
    color: #333;
    margin-bottom: 12px;
  }

  .method-list {
    .method-item {
      display: flex;
      align-items: center;
      padding: 12px 0;
      border-bottom: 1px solid #f5f5f5;

      span {
        flex: 1;
        margin-left: 12px;
        color: #333;
      }

      :deep(svg) {
        &:first-child {
          margin-right: 8px;
        }
      }
    }
  }
}

.bank-select {
  padding: 12px 0 12px 40px;
  border-bottom: 1px solid #f5f5f5;

  .selected-bank {
    color: #333;
    margin-bottom: 8px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;

    .change-bank {
      color: #0066FF;
    }
  }

  .add-bank {
    width: fit-content;
    margin-top: 12px;
    color: #767676;
    font-size: 14px;
    display: flex;
    align-items: center;

    :deep(svg) {
      margin-left: 4px;
    }
  }
}

.bottom-section {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 20px;
  background: #fff;

  .service {
    text-align: center;
    margin-bottom: 16px;
    font-size: 14px;
    color: #767676;

    span {
      color: #0066FF;
    }
  }

  .recharge-btn {
    width: 100%;
    height: 44px;
    background: #0066FF;
    color: #fff;
    border: none;
    border-radius: 22px;
    font-size: 16px;
    margin-bottom: 12px;
  }

  .agreement {
    text-align: center;
    font-size: 12px;
    color: #767676;

    span {
      color: #0066FF;
    }
  }
}

// 添加抽屉相关样式
.drawer-content {
  padding: 16px;

  .drawer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    border-bottom: 1px solid #f5f5f5;

    .close-icon {
      padding: 4px;
    }
  }

  .bank-list {
    .bank-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 0;
      border-bottom: 1px solid #f5f5f5;

      .bank-info {
        display: flex;
        align-items: center;

        .bank-detail {
          margin-left: 12px;

          .bank-name {
            font-size: 16px;
            color: #333;
          }

          .card-no {
            font-size: 14px;
            color: #666;
            margin-top: 4px;
          }
        }
      }
    }
  }
}
</style>
